import React from "react";
import { ENTITY_TYPE, WAREHOUSE_RETURN_ERROR_TYPE, WAREHOUSE_RETURN_SOURCE, WAREHOUSE_RETURN_STATUS } from "~/constants";
import { CHIP_COLOR_TYPES } from "../CustomChip.jsx";
import { faBan, faCheck, faExclamationTriangle, faHand, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { EntityActionStatusChipDeprecated } from "../../entityAction/EntityActionStatusChip.jsx";

export const WAREHOUSE_RETURN_ERROR_TYPE_MAP = {
    [WAREHOUSE_RETURN_ERROR_TYPE.UNKNOWN]: {
        label: "Unknown",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.API_ERROR]: {
        label: "Api Error",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.SKU_NOT_FOUND]: {
        label: "Sku not found",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.QUANTITY_TOO_HIGH]: {
        label: "Quantity too high",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.ITEM_NOT_REPORTED_THROUGH_TURNR]: {
        label: "Item not reported through turnr",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.ORDER_WITH_NOT_RETURNABLE_ITEM]: {
        label: "Non-returnable item",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.ORDER_NOT_REPORTED_THROUGH_TURNR]: {
        label: "Order not reported through turnr",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.FOREIGN_ORDER_NOT_FOUND]: {
        label: "Foreign order not found",
    },
    [WAREHOUSE_RETURN_ERROR_TYPE.FOREIGN_ORDER_MISMATCH]: {
        label: "Foreign order mismatch",
    },
};

export function getWarehouseReturnErrorTypeLabel(errorType) {
    return WAREHOUSE_RETURN_ERROR_TYPE_MAP?.[errorType]?.label || errorType;
}

export const WAREHOUSE_RETURN_STATUS_MAP = {
    [WAREHOUSE_RETURN_STATUS.NEW]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "New",
        icon: faCheck,
    },
    [WAREHOUSE_RETURN_STATUS.PROCESSING]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "Processing",
        icon: faSpinner,
    },
    [WAREHOUSE_RETURN_STATUS.PROCESSED]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Processed",
        icon: faCheck,
    },
    [WAREHOUSE_RETURN_STATUS.PLEASE_HANDLE_MANUALLY]: {
        colorType: CHIP_COLOR_TYPES.ACTION,
        label: "Handle manually",
        icon: faHand,
    },
    [WAREHOUSE_RETURN_STATUS.AWAITING_MERCHANT_CHECK]: {
        colorType: CHIP_COLOR_TYPES.ACTION,
        label: "Handle warehouse report",
        icon: faHand,
    },
    [WAREHOUSE_RETURN_STATUS.HANDLED_MANUALLY]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Handled manually",
        icon: faCheck,
    },
    [WAREHOUSE_RETURN_STATUS.ERROR]: {
        colorType: CHIP_COLOR_TYPES.ERROR,
        label: "Error",
        labelFn: ({ errorType }) => "Error" + (errorType ? ": " + getWarehouseReturnErrorTypeLabel(errorType) : ""),
        icon: faExclamationTriangle,
    },
    [WAREHOUSE_RETURN_STATUS.DUPLICATE]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Duplicate",
        icon: faCheck,
    },
    [WAREHOUSE_RETURN_STATUS.IGNORED]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Ignored",
        icon: faBan,
    },
};

export const WAREHOUSE_RETURN_SOURCE_MAP = {
    [WAREHOUSE_RETURN_SOURCE.BACKOFFICE]: {
        label: "Quality Check",
        // icon: "/icons/wms/turnr_wms.png",
    },
    [WAREHOUSE_RETURN_SOURCE.MERCHANT_API]: {
        label: "Merchant API",
    },
    [WAREHOUSE_RETURN_SOURCE.PRIME_PENGUIN_WEBHOOK]: {
        label: "Prime penguin webhook",
        icon: "/icons/wms/prime_penguin.png",
    },
    [WAREHOUSE_RETURN_SOURCE.SHIPHERO_WEBHOOK]: {
        label: "Shiphero webhook",
        icon: "/icons/wms/ship_hero.svg",
    },
    [WAREHOUSE_RETURN_SOURCE.ONGOING_WEBHOOK]: {
        label: "Ongoing webhook",
        icon: "/icons/wms/ongoing.svg",
    },
    [WAREHOUSE_RETURN_SOURCE.ORDER_WAREHOUSE_WORKER]: {
        label: "WMS integration",
    },
    [WAREHOUSE_RETURN_SOURCE.SHIPMONK_WORKER]: {
        label: "Shipmonk",
        icon: "/icons/wms/ship_monk.png",
    },
};

export function getWarehouseReturnSourceLabel(warehouseReturnSource) {
    return WAREHOUSE_RETURN_SOURCE_MAP?.[warehouseReturnSource]?.label || warehouseReturnSource;
}

export default function WarehouseReturnStatusChip(props) {
    const { entity, status } = props;
    return <EntityActionStatusChipDeprecated entityType={ENTITY_TYPE.WAREHOUSE_RETURN} statusData={WAREHOUSE_RETURN_STATUS_MAP[status || entity?.warehouseReturnStatus]} {...props} />;
}
